// src/components/SvgIcon/icons/finishFlag.tsx
const FinishFlagIcon = (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <path d="M5 3v18" />
    <path d="M5 4c6-2 8 2 14 0v9c-6 2-8-2-14 0V4z" fill="currentColor" opacity=".15" />
    <path d="M5 4c6-2 8 2 14 0v9c-6 2-8-2-14 0V4z" />
  </svg>
);
export default FinishFlagIcon;
